import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMasonry = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.625 8.4375H0.9375C0.42 8.4375 0 8.0175 0 7.5V0.9375C0 0.42 0.42 0 0.9375 0H5.625C6.1425 0 6.5625 0.42 6.5625 0.9375V7.5C6.5625 8.0175 6.1425 8.4375 5.625 8.4375Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.625 15H0.9375C0.42 15 0 14.58 0 14.0625V11.25C0 10.7325 0.42 10.3125 0.9375 10.3125H5.625C6.1425 10.3125 6.5625 10.7325 6.5625 11.25V14.0625C6.5625 14.58 6.1425 15 5.625 15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0625 5.625H9.375C8.8575 5.625 8.4375 5.205 8.4375 4.6875V0.9375C8.4375 0.42 8.8575 0 9.375 0H14.0625C14.58 0 15 0.42 15 0.9375V4.6875C15 5.205 14.58 5.625 14.0625 5.625Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0625 15H9.375C8.8575 15 8.4375 14.58 8.4375 14.0625V8.4375C8.4375 7.92 8.8575 7.5 9.375 7.5H14.0625C14.58 7.5 15 7.92 15 8.4375V14.0625C15 14.58 14.58 15 14.0625 15Z",
			fill: "currentColor"
		})
	]
});
export default SvgIconMasonry;
